import { RuleGuestAttributeResourceTypeRelation, RuleResourceTypeMustContain } from "../../../shared/types";
import { RelationRuleValidator } from "./types";

export const relationMustContain: RelationRuleValidator<
	RuleResourceTypeMustContain<RuleGuestAttributeResourceTypeRelation>
> = {
	validate: (rule, value) => {
		if (value == null) {
			return false;
		}

		switch (rule.guestAttribute.entityType) {
			case "tenant":
			case "tags":
			case "groups":
			case "guestType":
			case "region":
			case "wave": {
				const ruleArray = Array.isArray(rule.value) ? rule.value : [rule.value];
				const valueArray = Array.isArray(value) ? value : [value];

				return ruleArray.every((x) => valueArray.includes(x));
			}
			default:
				throw new Error("Not implemented rule");
		}
	},
};
